/* eslint-disable no-console */
import getEnvironmentName from '../lrs/lrsHelpers';

/**
 * Development logging utilities
 * Logs to console in dev and devci environments
 */

const isDevelopmentEnvironment = () => {
    const ENV = getEnvironmentName();
    if (process.env.NODE_ENV === 'development' || ENV === 'devci') {
        return true;
    }
    return false;
};

export const devLog = (...args) => {
    if (isDevelopmentEnvironment()) {
        console.log(...args);
    }
};

export const devWarn = (...args) => {
    if (isDevelopmentEnvironment()) {
        console.warn(...args);
    }
};

export const devError = (...args) => {
    if (isDevelopmentEnvironment()) {
        console.error(...args);
    }
};

export const devInfo = (...args) => {
    if (isDevelopmentEnvironment()) {
        console.info(...args);
    }
};

/**
 * Creates a namespaced dev logger with a prefix
 * @param {string} namespace - Prefix for all log messages
 * @returns {object} Object with log, warn, error, info methods
 */
export const createDevLogger = namespace => ({
    log: (...args) => devLog(`[${namespace}]`, ...args),
    warn: (...args) => devWarn(`[${namespace}]`, ...args),
    error: (...args) => devError(`[${namespace}]`, ...args),
    info: (...args) => devInfo(`[${namespace}]`, ...args),
});

export default devLog;
